import { CardExpiryElement } from '@stripe/react-stripe-js';
import { FormattedMessage, useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { stripeElementStyles } from '../../ElementStyles';

export const ExpiryDateField = ({
    error,
    onChange
}: {
    error: boolean | null;
    onChange: (response: any) => void;
}) => {
    const intl = useIntl();

    const errorMessage = intl.formatMessage({
        id: '_.link_debit_card.expiry_date_error',
        defaultMessage: 'Invalid expiry date'
    });

    return (
        <DebitCardFieldWrapper
            label={
                <FormattedMessage
                    id="_.link_debit_card.expiry_date"
                    defaultMessage="Expiry date"
                />
            }
            error={error ? errorMessage : null}
        >
            <CardExpiryElement
                onChange={onChange}
                options={{ style: stripeElementStyles }}
            />
        </DebitCardFieldWrapper>
    );
};
